const ShowAllButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      className="text-[#155FCC] text-xs cursor-pointer"
      onClick={onClick}
      data-testid="table-cell-show-all-button"
    >
      Show all
    </button>
  );
};

export default ShowAllButton;
